<template>
  <v-container class="fill-height background-wrapper" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-card>
          <div style="display: flex; justify-content: flex-end; padding: 8px;">
            <LanguageSwitcher />
          </div>
          <v-card-title class="primary">
            <span class="headline">{{ $t('login.title') }}</span>
          </v-card-title>
          <v-card-text>
            <v-form @submit.prevent="login">
              <PhoneNumberInput v-model="phoneNumber" @input-change="updatePhoneNumber"/>

              <v-btn
                  block type="submit"
                  :class="{ 'custom-btn-active': isPhoneNumberValid, 'custom-btn-inactive': !isPhoneNumberValid }"
                  :disabled="!isPhoneNumberValid"
              >
                {{ $t('login.button') }}
              </v-btn>

              <v-divider class="border-opacity-50 mt-8" color="success" />

              <div class="mt-8">
                <v-btn
                    color="cyan-accent-4"
                    block
                    @click="$router.push('/send-otp')"
                    prepend-icon="mdi-message-text-outline"
                >
                 {{ $t('login.sms') }}
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { BACKEND_API_ENDPOINT } from '@/api'
import axios from 'axios'
import PhoneNumberInput from '@/components/PhoneNumberInput.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

axios.defaults.withCredentials = true;

export default {
  components: {
    PhoneNumberInput,
    LanguageSwitcher,
  },
  data() {
    return {
      phoneNumber: '',
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(BACKEND_API_ENDPOINT + '/send-whatsapp-otp', {
          phone: this.phoneNumber
        });

        if (response.data.status === 'success') {
          localStorage.setItem('sent_otp', response.data.data.sent_otp);
          localStorage.setItem('phone_number', response.data.data.phone_number);
          localStorage.setItem('method', response.data.data.method)

          this.$router.push('/verify-otp');
        } else {
          console.error('Ошибка при отправке OTP-кода:', response.data.message);
        }
      } catch (error) {
        console.error('Ошибка при отправке запроса:', error);
      }
    },
    updatePhoneNumber(newNumber) {
      this.phoneNumber = newNumber;
    }
  },
  computed: {
    isPhoneNumberValid() {
      return /^\+996\s?\d{9}$|^\+7\s?\d{10}$/.test(this.phoneNumber);
    }
  },
}
</script>

<style scoped>
.background-wrapper {
  background-color: #71b646;
}

.custom-btn-active {
  background: linear-gradient(241.48deg, #07a01d -24.3%, #d5cb6c 172.89%);;
  color: white;
  font-weight: bolder;
  padding: 12px 0
}

.custom-btn-inactive {
  background-color: #F8F8F8;
  color: black;
  font-weight: bolder;
  padding: 20px 0
}
</style>
